import React, { Fragment } from "react"; 
import HelmetComponent from "../components/common/HelmetComponent";
import FirstSection from "../components/home/FirstSection";
import SocialMediaSection from "../components/home/SocialMediaSection";
import ReviewSection from "../components/home/ReviewSection";
import ContentOne from "../components/home/ContentOne";
import ContentTwo from "../components/home/ContentTwo";
import DailyAiInsightsCard from "../components/home/DailyAiInsightsCard";
import QuizCardSection from "../components/home/QuizCardSection";
import AiPracticeSection from "../components/home/AiPracticeSection";
import LearningPathSection from "../components/home/LearningPathSection";
import BorderLine from "../components/common/BorderLine";

const Home = () => { 
  return (
    <Fragment>
      <HelmetComponent
        title="Fluent Fable | Fluent Fable is a tool to boost English skills with interactive pdfs"
        name="description"
        content="Fluent Fable is a tool to boost English skills with interactive tools and downloadable PDF resources for effective language learning and practice."
      />
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <FirstSection />
      </div>
      <BorderLine />
      <div
        id="comprehensive-mastery"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <ContentOne />
      </div>
      <BorderLine />
      <div
        id="conversational-english"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <ContentTwo />
      </div>
      <BorderLine />
      <div
        id="ai-insights"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <DailyAiInsightsCard />
      </div>
      <BorderLine />
      <div
        id="interactive-quizzes"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <QuizCardSection />
      </div>
      <BorderLine />
      <div
        id="ai-practice"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <AiPracticeSection />
      </div>
      <BorderLine />
      <div
        id="learning-path"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <LearningPathSection />
      </div>
      <BorderLine />
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <SocialMediaSection />
      </div>
      <BorderLine />
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: 1208,
        }}
      >
        <ReviewSection />
      </div>
    </Fragment>
  );
};

export default Home;
